import React from 'react';
import R_Logo from '../Images/R_Logo.png';

/**
 * The Reliable Software mark, linked to their site.
 *
 * One component so the URL and the rel/target attributes live in a single
 * place - the logo was previously a bare <img> repeated across six headers.
 * rel="noreferrer" matters with target="_blank": without it the opened page
 * gets a handle on this window via window.opener.
 */
export const RELYSOFT_URL = 'https://relysoft.in/';

const RelysoftLink = ({ className = '', style, title = 'Reliable Software' }) => (
    <a
        href={RELYSOFT_URL}
        target="_blank"
        rel="noopener noreferrer"
        title={title}
        aria-label={title}
        className='relysoftLink'
    >
        <img src={R_Logo} className={className} style={style} alt={title} />
    </a>
);

export default RelysoftLink;
